module.exports = __webpack_public_path__ + "img/step_one.28ab0ada.jpg";